import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["SUSTAINABLE", "HYPERLOCAL", "40X NUTRITION", "SAME-DAY HARVEST", "GROWN IN YOUR PINCODE"];

export const BrandMarquee = ({ dark = false }) => (
  <div
    data-testid="brand-marquee"
    className={`py-8 md:py-12 border-y ${dark ? "border-white/10 bg-brand-dark" : "border-black/10 bg-brand-card"}`}
  >
    <Marquee speed={40} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-serif italic text-4xl md:text-6xl px-8 ${
              dark ? "text-brand-bg/90" : "text-brand-forest"
            }`}
          >
            {w}
          </span>
          <span className="text-brand-sprout text-3xl md:text-5xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
